import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withModifiers as _withModifiers, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, vModelCheckbox as _vModelCheckbox, createCommentVNode as _createCommentVNode, withKeys as _withKeys, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", { class: "nge-photo-title" }, "Photo mode", -1 /* HOISTED */)
const _hoisted_2 = ["title"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("svg", {
  viewBox: "0 0 24 24",
  width: "16",
  height: "16",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "1.8",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M20 12a8 8 0 1 1-2.6-5.9" }),
  /*#__PURE__*/_createElementVNode("path", { d: "M20 4v4h-4" })
], -1 /* HOISTED */)
const _hoisted_4 = {
  class: "nge-photo-group",
  title: "Spin speed"
}
const _hoisted_5 = ["onClick"]
const _hoisted_6 = {
  class: "nge-photo-group",
  title: "Which way it turns"
}
const _hoisted_7 = ["onClick"]
const _hoisted_8 = {
  class: "nge-photo-check",
  title: "How many seconds a speed change or a fade takes. 0 is at once."
}
const _hoisted_9 = {
  class: "nge-photo-group",
  title: "Fade the cells in or out"
}
const _hoisted_10 = {
  class: "nge-photo-group",
  title: "Background"
}
const _hoisted_11 = ["title", "aria-label", "onClick"]
const _hoisted_12 = ["disabled"]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("svg", {
  viewBox: "0 0 24 24",
  width: "16",
  height: "16",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "1.8",
  "stroke-linecap": "round"
}, [
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "12",
    cy: "12",
    r: "3"
  }),
  /*#__PURE__*/_createElementVNode("path", { d: "M12 2v4M12 18v4M2 12h4M18 12h4" })
], -1 /* HOISTED */)
const _hoisted_14 = {
  class: "nge-photo-check",
  title: "A small Pyr mark in the corner of pictures and recordings"
}
const _hoisted_15 = ["disabled"]
const _hoisted_16 = /*#__PURE__*/_createElementVNode("svg", {
  viewBox: "0 0 24 24",
  width: "16",
  height: "16",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "1.8",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M3 8h3l2-2.5h8L18 8h3v11H3z" }),
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "12",
    cy: "13.5",
    r: "3.8"
  })
], -1 /* HOISTED */)
const _hoisted_17 = {
  class: "nge-photo-group",
  title: "MP4 plays almost anywhere. GIF is smaller and loops, good for the forum."
}
const _hoisted_18 = ["disabled", "onClick"]
const _hoisted_19 = ["title"]
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", { class: "nge-photo-dot" }, null, -1 /* HOISTED */)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", null, "Click a spot on a cell to turn around it, or type a point:", -1 /* HOISTED */)
const _hoisted_22 = ["onKeydown"]
const _hoisted_23 = {
  key: 1,
  class: "nge-photo-note",
  "data-nge-capture-skip": ""
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createElementVNode("div", {
      class: _normalizeClass(["nge-photo-flash", { on: $setup.flash }]),
      "data-nge-capture-skip": ""
    }, null, 2 /* CLASS */),
    _createElementVNode("div", {
      class: _normalizeClass(["nge-photo-bar", { idle: $setup.idle && !$setup.recording && !$setup.picking }]),
      "data-nge-capture-skip": "",
      onMouseenter: $setup.wake,
      onPointerdown: _cache[8] || (_cache[8] = _withModifiers(() => {}, ["stop"]))
    }, [
      _hoisted_1,
      _createElementVNode("button", {
        class: _normalizeClass(["nge-photo-btn", { on: $setup.spinning }]),
        title: $setup.spinning ? 'Stop the spin (Space)' : 'Spin (Space)',
        onClick: _cache[0] || (_cache[0] = $event => ($setup.spinning = !$setup.spinning))
      }, [
        _hoisted_3,
        _createTextVNode(" " + _toDisplayString($setup.spinning ? 'Spinning' : 'Spin'), 1 /* TEXT */)
      ], 10 /* CLASS, PROPS */, _hoisted_2),
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList($setup.SPEEDS, (s) => {
          return _createElementVNode("button", {
            key: s.id,
            class: _normalizeClass(["nge-photo-chip", { on: $setup.speedId === s.id }]),
            onClick: $event => {$setup.speedId = s.id; $setup.spinning = true}
          }, _toDisplayString(s.label), 11 /* TEXT, CLASS, PROPS */, _hoisted_5)
        }), 64 /* STABLE_FRAGMENT */))
      ]),
      _createElementVNode("div", _hoisted_6, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList($setup.AXES, (a) => {
          return _createElementVNode("button", {
            key: a.id,
            class: _normalizeClass(["nge-photo-chip", { on: $setup.axisId === a.id }]),
            onClick: $event => ($setup.axisId = a.id)
          }, _toDisplayString(a.label), 11 /* TEXT, CLASS, PROPS */, _hoisted_7)
        }), 64 /* STABLE_FRAGMENT */))
      ]),
      _createElementVNode("label", _hoisted_8, [
        _createTextVNode(" Change over "),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (($setup.changeSeconds) = $event)),
          class: "nge-photo-secs",
          type: "number",
          min: "0",
          max: "60",
          step: "0.5",
          onKeydown: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"]))
        }, null, 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
          [
            _vModelText,
            $setup.changeSeconds,
            void 0,
            { number: true }
          ]
        ]),
        _createTextVNode(" s ")
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("button", {
          class: _normalizeClass(["nge-photo-chip", { on: $setup.fading === 'in' }]),
          onClick: _cache[3] || (_cache[3] = $event => ($setup.startFade('in')))
        }, "Fade in", 2 /* CLASS */),
        _createElementVNode("button", {
          class: _normalizeClass(["nge-photo-chip", { on: $setup.fading === 'out' }]),
          onClick: _cache[4] || (_cache[4] = $event => ($setup.startFade('out')))
        }, "Fade out", 2 /* CLASS */)
      ]),
      _createElementVNode("div", _hoisted_10, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList($setup.BACKGROUNDS, (b) => {
          return _createElementVNode("button", {
            key: b.id,
            class: _normalizeClass(["nge-photo-swatch", { on: $setup.bgId === b.id }]),
            title: b.label + ' background',
            "aria-label": b.label + ' background',
            style: _normalizeStyle($setup.swatchStyle(b.rgb)),
            onClick: $event => ($setup.setBackground(b.id))
          }, null, 14 /* CLASS, STYLE, PROPS */, _hoisted_11)
        }), 64 /* STABLE_FRAGMENT */))
      ]),
      _createElementVNode("button", {
        class: _normalizeClass(["nge-photo-btn", { on: $setup.picking }]),
        disabled: $setup.recording,
        title: "Choose the point the spin turns around",
        onClick: $setup.startPicking
      }, [
        _hoisted_13,
        _createTextVNode(" Pick centre ")
      ], 10 /* CLASS, PROPS */, _hoisted_12),
      _createElementVNode("label", _hoisted_14, [
        _withDirectives(_createElementVNode("input", {
          type: "checkbox",
          "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => (($setup.watermark) = $event))
        }, null, 512 /* NEED_PATCH */), [
          [_vModelCheckbox, $setup.watermark]
        ]),
        _createTextVNode(" Pyr mark ")
      ]),
      _createElementVNode("button", {
        class: "nge-photo-btn primary",
        disabled: $setup.recording,
        title: "Save a picture of the 3D view",
        onClick: $setup.savePicture
      }, [
        _hoisted_16,
        _createTextVNode(" Save picture ")
      ], 8 /* PROPS */, _hoisted_15),
      _createElementVNode("div", _hoisted_17, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList($setup.FORMATS, (f) => {
          return _createElementVNode("button", {
            key: f.id,
            class: _normalizeClass(["nge-photo-chip", { on: $setup.formatId === f.id }]),
            disabled: $setup.recording,
            onClick: $event => ($setup.formatId = f.id)
          }, _toDisplayString(f.label), 11 /* TEXT, CLASS, PROPS */, _hoisted_18)
        }), 64 /* STABLE_FRAGMENT */))
      ]),
      _createElementVNode("button", {
        class: _normalizeClass(["nge-photo-btn primary", { rec: $setup.recording }]),
        title: $setup.recording ? 'Stop recording (Esc)' : 'Record one full turn, as it turns on screen',
        onClick: _cache[6] || (_cache[6] = $event => ($setup.recording ? $setup.stopRecording() : $setup.recordSpin()))
      }, [
        _hoisted_20,
        ($setup.recording)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createTextVNode("Recording " + _toDisplayString($setup.recordPercent) + "%", 1 /* TEXT */)
            ], 64 /* STABLE_FRAGMENT */))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createTextVNode("Record spin")
            ], 64 /* STABLE_FRAGMENT */))
      ], 10 /* CLASS, PROPS */, _hoisted_19),
      _createElementVNode("button", {
        class: "nge-photo-btn",
        title: "Leave photo mode (Esc)",
        onClick: _cache[7] || (_cache[7] = $event => ($setup.emit('hide')))
      }, "Exit")
    ], 34 /* CLASS, HYDRATE_EVENTS */),
    ($setup.picking)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "nge-photo-pick",
          "data-nge-capture-skip": "",
          onPointerdown: _cache[10] || (_cache[10] = _withModifiers(() => {}, ["stop"])),
          onKeydown: _cache[11] || (_cache[11] = _withModifiers(() => {}, ["stop"]))
        }, [
          _hoisted_21,
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => (($setup.coordText) = $event)),
            class: "nge-photo-coords",
            placeholder: "x, y, z",
            spellcheck: "false",
            onKeydown: _withKeys(_withModifiers($setup.useTypedCoords, ["prevent"]), ["enter"])
          }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_22), [
            [_vModelText, $setup.coordText]
          ]),
          _createElementVNode("button", {
            class: "nge-photo-btn primary",
            onClick: $setup.useTypedCoords
          }, "Use point"),
          _createElementVNode("button", {
            class: "nge-photo-btn",
            onClick: $setup.stopPicking
          }, "Cancel")
        ], 32 /* HYDRATE_EVENTS */))
      : _createCommentVNode("v-if", true),
    ($setup.note)
      ? (_openBlock(), _createElementBlock("div", _hoisted_23, _toDisplayString($setup.note), 1 /* TEXT */))
      : _createCommentVNode("v-if", true),
    _createElementVNode("div", {
      class: _normalizeClass(["nge-photo-hint", { idle: $setup.idle }]),
      "data-nge-capture-skip": ""
    }, "Drag to turn the cell yourself. Esc to leave.", 2 /* CLASS */)
  ]))
}